import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Button } from '@mui/material';
import { FaUser } from "react-icons/fa";
import { Stack } from '@mui/system';
import { useState } from 'react';
import { useEffect } from 'react';
import { GetSignOnPending } from 'API/DS_Wallet/api';
import SignOnAlertDialog from './AlertBoxSignon';
import BackdropLoader from '../General/Loader';




// function createData(name, code, population, size) {
//   const density = population / size;
//   return { name, code, population, size, density };
// }


export default function SignOnTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const[rows,setRows]=useState(null)

  const[SelectedData,setSelectedData]=useState(null)
  const[open,setOpen]=useState(false)
  const[isLoading,setIsLoading]=useState(false)

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    return `${formattedDate}`;
  }

  const handleOpen=()=>{
    setOpen(true)
  }

  const handleClose=()=>{
    setOpen(false)
  }


  useEffect(()=>{
    GetSignOnPending(setRows,setIsLoading,page+1)
  },[])


  const handleChangePage = (event, newPage) => {
    GetSignOnPending(setRows,setIsLoading,newPage+1)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleOpenAlert=(row)=>{
    console.log("Hitteld alert");

    setSelectedData(row)
    handleOpen()
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <BackdropLoader open={isLoading} />
      <SignOnAlertDialog open={open} handleClose={handleClose} SelectedData={SelectedData}/>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table" size='small'>
          <TableHead>
            <TableRow>
            <TableCell align='center'>Agent Name</TableCell>
            <TableCell align='center'>Agent Code</TableCell>
            <TableCell align='center'>Address</TableCell>
            <TableCell align='center'>Date of Joining</TableCell>
            <TableCell align='center'>Due Date</TableCell>
            <TableCell align='center'>Amount Recieved</TableCell>
            <TableCell align='center'>Amount Due</TableCell>
              <TableCell align='center'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows&&Array.isArray(rows.data)&&rows.data.length>0
            ?rows.data
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.aadhaar_name}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.user_code}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.customer_details.retail_address}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.created_at?formatDate(row.created_at):"N/A"}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.installment_1_due_date.split("-").reverse().join("-")}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.installment_1_amount_received}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                      {row.installment_1_pending_amount}
                    </TableCell>
                    <TableCell sx={{textAlign:'center'}}>
                        <Stack direction='row' gap={1}>
                            <Button variant='contained' color='secondary' onClick={()=>handleOpenAlert(row)}>Pay now</Button>
                            <Button sx={{display:"none"}} variant='contained' color='secondary'><FaUser /></Button>
                        </Stack>
                    </TableCell>
                  </TableRow>
                );
              })
              :
             <TableRow colSpan={8}><Stack width="100%" justifyContent="center" alignItems="center"> No data</Stack></TableRow>
            }


          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10]}
        component="div"
        count={rows&&rows.total_count?rows.total_count:0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
